import * as angular from 'angular';

interface QueryParamObject {
    [key: string]: string;
}

export function appendQueryParametersToUrl(url: string, queryParamObject: QueryParamObject) {
    let outputUrl = url;
    const getUrlSeparator = (urlToExtractSeparatorFrom: string) => {
        return urlToExtractSeparatorFrom.indexOf('?') !== -1 ? '&' : '?';
    };

    for (const queryParamObjectKey in queryParamObject) {
        if (queryParamObject[queryParamObjectKey]) {
            const queryParamObjectKeyValue = queryParamObject[queryParamObjectKey];
            if (queryParamObjectKeyValue) {
                const separator = getUrlSeparator(outputUrl);
                outputUrl = `${outputUrl}${separator}${queryParamObjectKey}=${queryParamObjectKeyValue}`;
            }
        }
    }

    return outputUrl;
}

const module = angular.module('customerPortal.utilities.urls', []);

module.value('appendQueryParametersToUrl', appendQueryParametersToUrl);
